import { JSX } from "react";
import { Color } from "../../models/helpers/colors.ts";
import formatNumber from "../../models/helpers/formatNumber.ts";

const FormInput = ({
    entity,
    fieldName,
    handleInputChange,
    handleKeyDown,
    handleBlur,
    mappingName,
    showLabel = true,
    label,
    type,
    inputMode,
    prepend,
    append,
    handleAppendOnClick,
    toFixed,
    mb = 3,
    disabled = false,
    errors,
    errorColor = Color.danger
}: {
    entity: any;
    fieldName: string;
    handleInputChange: any;
    handleKeyDown?: any;
    handleBlur?: any;
    mappingName?: string;
    showLabel?: boolean;
    label?: string;
    type?: "search" | "email" | "tel" | "text" | "url" | "none" | "numeric" | "decimal" | "password" | undefined;
    inputMode?: "search" | "email" | "tel" | "text" | "url" | "none" | "numeric" | "decimal" | undefined;
    prepend?: string | JSX.Element;
    append?: string | JSX.Element;
    handleAppendOnClick?: any;
    toFixed?: number;
    mb?: number;
    disabled?: boolean;
    errors?: any;
    errorColor?: string;
}) => {
    return (
        <div className={`input-group has-validation ${mb && mb > 0 ? `mb-${mb}` : ''}`}>
            {prepend && <span className="input-group-text" style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}>{prepend}</span>}
            <div className={`form-floating ${errors?.[fieldName] && 'is-invalid'}`}>
                <input
                    type={type ? type : fieldName}
                    inputMode={inputMode ? inputMode : type && type != "password" ? type : undefined}
                    className={`form-control ${errors?.[fieldName] && 'is-invalid'}`}
                    id={fieldName}
                    name={mappingName}
                    value={(toFixed && type == 'decimal' ? formatNumber.ToFixed(entity[fieldName], toFixed) : entity[fieldName]) ?? ''}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    onBlur={handleBlur}
                    style={append ? {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0,
                        borderColor: errors?.[fieldName] ? errorColor : undefined
                    } :
                        {}
                    }
                    readOnly={disabled}
                />
                {showLabel && <label htmlFor={fieldName}>{label ? label : fieldName}</label>}
            </div>
            {append && <span className="input-group-text" onClick={handleAppendOnClick}>{append}</span>}
            {
                errors?.[fieldName] && (
                    <div className="invalid-feedback" style={{ color: errorColor }}>
                        {errors?.[fieldName]}
                    </div>
                )
            }
        </div >
    );
};

export default FormInput;
